import { render } from "./Info.vue?vue&type=template&id=48d9a401"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=48d9a401&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__